import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
/**
 * Componentes
 */
//Componente que contiene los elementos del Header del sitio
import Header from '../components/header';
//Componente que indica el usuario que se encuentra logeado
import UserTop from '../components/userTop';
//Componente que contiene la infrmación de pacientes pendientes de alta
import PacientesPendientes from '../components/pacientesSection';
//Componente que contiene la información de los usuarios que pueden ingresar al sistema
import Usuarios from '../components/usuariosSection';
//Componente que contiente información de los logs de actividades
import LogsSection from '../components/logsSection';
//Componente que contiene los elementos del Footer del sitio
import Footer from '../components/footer';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { descrifrar } from '../../utils/functions';

/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, surgeryroomCollection } from '../../firebase/config';

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaName, getUnidadHospitalariaValue } from '../../objects/unidadHospitalaria';
import { updatePatient } from '../../objects/patient';

/**
 * Page asignada al control de pacientes pendientes de salida de quirófano
 * @param {Object} param0 Recibe los objetos necesarios para guardar la información de sesión
 * @returns Component Devuelve el sitio con los elementos y funcionalidad asignada
 */
const PacientesSalidaQuirofano = ({userName,userNomHospital,userLevel,uhList,access}) => {

    //Estado que indica que se esta solicitando información al servicio
    const [isLoader,setIsLoader] = useState(false)
    //Estado que almacena si esta activa la opción pacientes del menu
    const [isMostrarPacientes,setIsMostrarPacientes] = useState(true)
    //Estado que almacena si esta activa la opción pacientes del menu
    const [isMostrarRecuperacion,setIsMostrarRecuperacion] = useState(false)
    //Estado que almacena si esta activa la opción usuarios del menu
    const [isMostrarUsuarios,setIsMostrarUsuarios] = useState(false)
    //Estado que almacena los pacientes obtenidos desde la base de datos en una lista
    const [pacientesList,setPacientesList] = useState([])
    //Estado que almacena el nombre de la opción que ha elegido el usuario para utilizarse en la permanencia
    const [pageActive,setPageActive] = useState(sessionStorage.getItem('active'))
    //Estado que almacena la cantidad total de pacientes en quirófano
    const [totalQuirofano,setTotalQuirofano] = useState(0)
    //Estado que almacena la cantidad total de pacientes en recuperación
    const [totalRecuperacion,setTotalRecuperacion] = useState(0)

    useEffect(()=>{
        setIsLoader(true)
        pacientesStore.collection(surgeryroomCollection)
        .onSnapshot(snap => {
            const pacientes = []
            snap.forEach(doc => {
                pacientes.push({ id: doc.id, ...doc.data() })
            })

            const busqueda = pacientes.reduce((acc, persona) => {
                acc[persona.NumeroDePaciente] = ++acc[persona.NumeroDePaciente] || 0;
                return acc;
              }, {});
              
              const duplicados = pacientes.filter( (persona) => {
                  return busqueda[persona.NumeroDePaciente];
              });
              
              let posicion = 0
              for(let i=0;i<duplicados.length;i++){
                if(duplicados[i].contacts){
                    posicion = i
                }
              }
              
              for(let i=0;i<duplicados.length;i++){
                if(i!==posicion){
                    solicitarCambioEstado()
                    async function solicitarCambioEstado(){
                        await updatePatient(duplicados[i],"Cancelación",false,"pendiente")
                    }
                }
              }

            //inicio
            let cantidadPacientesQuirofano = 0
            let cantidadPacientesRecuperacion = 0
            let pacientesValidos = 0
            pacientes.forEach(
                    paciente => {
                        if(userLevel !== "superuser"){
                            let uhName = getUnidadHospitalariaValue(paciente.UnidadHospitalaria)
                                if(getUnidadHospitalariaName(descrifrar(userNomHospital).toString(),uhList) === getUnidadHospitalariaName(uhName,uhList)
                                    && paciente.Status !== "Salida"){
                                        pacientesValidos = pacientesValidos + 1 
                                        if(!paciente.Status || paciente.Status === "Quirofano"){//Paciente en quirófano
                                            cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                        }
                                        else{
                                            if(paciente.Status === "Especial"){//Paciente en caso especial
                                                if(paciente.lastEstatus === "Quirófano"){
                                                    cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                                }
                                                else{
                                                    cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                                }
                                            }
                                            else{//Paciente en recuepración
                                                cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                            }
                                        }
                                }
                        }
                        else{
                            if(paciente.Status !== "Salida"){
                                pacientesValidos = pacientesValidos + 1
                                if(!paciente.Status || paciente.Status === "Quirofano"){//Paciente en quirófano
                                    cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                }
                                else{
                                    if(paciente.Status === "Especial"){//Paciente en caso especial
                                        if(paciente.lastEstatus === "Quirófano"){
                                            cantidadPacientesQuirofano = cantidadPacientesQuirofano + 1
                                        }
                                        else{
                                            cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                        }
                                    }
                                    else{//Paciente en recuepración
                                        cantidadPacientesRecuperacion = cantidadPacientesRecuperacion + 1
                                    }
                                }
                            }
                        }
                    }
                )

            if(pacientesValidos > 0){//Se verifica si existen pacientes que pertenezcan a la unidad hospitalaria requerida
                //setCantidadPacientes(pacientesValidos)
                setTotalQuirofano(cantidadPacientesQuirofano)
                setTotalRecuperacion(cantidadPacientesRecuperacion)
                
            }
            else{//No se encientraron pacientes pertenecientes a la unidad hospitalaria
                setTotalQuirofano(0)
                setTotalRecuperacion(0)
            }
            //fin

            if(localStorage.getItem("almacenamiento")){//Se verifica si se cuenta con registro de los pacientes que ha visualizado el usuario logeado
                //Se obtiene el array con los pacientes que ya ha visualizado el usuario
                let pacientesEnMemoria = JSON.parse(localStorage.getItem('almacenamiento'))
                /**
                 * Función que muestra si hay nuevos pacientes disponibles en el sistema
                 * @param {Array} originalArray Recibe los pacientes que ya han sido visualizado por el usuario logeado
                 * @param {Array} nuevoArray Recibe los pacientes obtenidos en la coleccion de surgeryroom
                 * @returns Boolean Devuelve si ha encontrado nuevos pacientes
                 */
                const hadNewPatient = (originalArray,nuevoArray) => {
                    nuevoArray.forEach(paciente => {
                        //Se busca si en el array de memoria se encuentran los elementos del arrar de la colección surgeryroom
                        const resultado = originalArray.find( pacienteOriginal => pacienteOriginal.id === paciente.id );
                        if(!resultado){//Se verifica si no se ha encontrado el paciente de la coleccion surgeryroom en la memoria
                            if(userLevel !== "superuser"){//User logeado con permisos de tipo Administrador o Normal
                                if(paciente.hospitalId.toString() === descrifrar(userNomHospital).toString() && userLevel !== "recuperación"){//Se verifica que el nuevo paciente corresponda a la unidad hospitalaria del user logeado y se muestra la notificación
                                    // const audioEl = document.getElementById('notificacion')
                                    // audioEl.play()
                                    Swal.fire({
                                        icon:"warning",
                                        title:"Atención!",
                                        confirmButtonText: "Aceptar",
                                        confirmButtonColor: "#04afaa",
                                        text:"Nuevos pacientes disponibles.",
                                        allowOutsideClick:false,
                                      })
                                      .then((res)=>{
                                        if(res.isConfirmed){
                                            //setPlaying(false)
                                        }
                                      })
                                    return true
                                }
                            }
                            else{//Si el user logeado tiene acceso total se muestra la notificación de nuevos pacientes
                                //const audioEl = document.getElementById('notificacion')
                                //audioEl.play()
                                Swal.fire({
                                    icon:"warning",
                                    title:"Atención!",
                                    confirmButtonText: "Aceptar",
                                    confirmButtonColor: "#04afaa",
                                    text:"Nuevos pacientes disponibles.",
                                    allowOutsideClick:false,
                                  })
                                  .then((res)=>{
                                    if(res.isConfirmed){
                
                                    }
                                  })
                                return true
                            }
                        }
                    })
                    return false
                }
                hadNewPatient(pacientesEnMemoria,pacientes)
            }
            //Se guarda en memoria la nueva lista de pacientes
            localStorage.setItem("almacenamiento",JSON.stringify(pacientes))
            setIsLoader(false)
            setPacientesList(pacientes)
        },(error)=>{
            setIsLoader(false)
            setPacientesList([])
            Swal.fire({
                icon: 'error',                title: 'Error',
                text: error,
              })
        })
    },[userNomHospital,userLevel,totalQuirofano,uhList])


    useEffect(()=>{
        if(pageActive){
            if(pageActive === "pacientes"){
                setIsMostrarPacientes(true)
            }
            else{
                setIsMostrarPacientes(false)
            }
        }
        else{
            if(userLevel === "recuperación"){
                setPageActive('recuperacion')
                sessionStorage.setItem('active','recuperacion')
                setIsMostrarRecuperacion(true)
            }
            else{
                setPageActive('pacientes')
                sessionStorage.setItem('active','pacientes')
            }
        }
    },[pageActive,userLevel])

    return(
        <>
            <audio>
                <source src="https://assets.coderrocketfuel.com/pomodoro-times-up.mp3"></source>
            </audio>
            <div id="seccionCabeceraLogin" className='seccionCabeceraLogin'>
                <Header access={access} nomHospital={userNomHospital} name={userName} uhList={uhList} userLevel={userLevel}/>
                <UserTop nomHospital={userNomHospital} name={userName} uhList={uhList} userLevel={userLevel} 
                setIsMostrarPacientes={setIsMostrarPacientes} isMostrarPacientes={isMostrarPacientes}
                setIsMostrarUsuarios={setIsMostrarUsuarios} isMostrarUsuarios={isMostrarUsuarios}
                setIsMostrarRecuperacion={setIsMostrarRecuperacion} isMostrarRecuperacion={isMostrarRecuperacion}
                totalQuirofano={totalQuirofano} totalRecuperacion={totalRecuperacion}/>
            </div>
            <br />
            <div className='cuerpoPacientes'>
            {
                isMostrarPacientes
                ?   
                    <PacientesPendientes nomHospital={userNomHospital} userLevel={userLevel} uhList={uhList} name={userName} 
                        isMostrarPacientes={isMostrarPacientes} setTotalQuirofano={setTotalQuirofano} 
                        setTotalRecuperacion={setTotalRecuperacion} totalQuirofano={totalQuirofano}
                        isLoader={isLoader} pacientesList={pacientesList}/>
                :   isMostrarUsuarios
                    ?   
                        <Usuarios uhList={uhList} userLevel={userLevel} nomHospital={userNomHospital}/>
                    :   isMostrarRecuperacion
                        ? <PacientesPendientes nomHospital={userNomHospital} userLevel={userLevel} uhList={uhList} 
                            name={userName} isMostrarPacientes={isMostrarPacientes} setTotalQuirofano={setTotalQuirofano} 
                            setTotalRecuperacion={setTotalRecuperacion} totalQuirofano={totalQuirofano}
                            isLoader={isLoader} pacientesList={pacientesList}/>
                        : <LogsSection nomHospital={userNomHospital} userLevel={userLevel} uhList={uhList} name={userName}/>
            }
            <Footer/>
            </div>
        </>
    )
}

export default PacientesSalidaQuirofano;